import Vue from "vue";
import Vuesax from "vuesax";
Vue.use(Vuesax);